export default "__VITE_ASSET__BBa_x1pN__"